
enum AUTHPATHS {
    Login = `/login`,
    ResetPassword = `reset-password`,
}

enum PRIVATEPATHS {
    Dashboard = `/dashboard`,
    UserListing = `/user-listing`,
    Offers = `/offers`,
    Products = `/products`,
    Dosage = `/dosage`,
    Tier = `/tier`,
    Warehouse = `/warehouse`,
    Manufacturer = `/manufacturer`,
    Supplier = `/supplier`,
    ProductCategory = `/product-category`,
    ProductSubCategory = `/product-sub-category`,
    Batch = `/batch`,
    InventoryManagement = `/inventory-management`,
    ProductLifeCycle = `/product-life-cycle`,
    Traceability = `/traceability`,
    TransactionStatements = `/transaction-statements`,
    Audit = `/audit`,
    Epcis = `/epcis`,
    SftpIntegrations = `/sftp-integrations`,
    SftpPartners = `/sftp-integrations/partners`,
    Integrations = `/integrations`,
    As2Messages = `/as2-messages`,
    As2Partners = `/as2-messages/partners`,
    Bullk = `/bullk`,
    Orders = `/orders`,
    Backorders = `/backorders`,
    Comments = `/comments`, 
    Alert = `/alert`,
    Map = `/map`,
    Returns = `/returns`,
    Shipments = `/shipments`,
    ContactSubmissions = `/contact-submissions`,
    PosSettings = `/pos-settings`,
}

export { AUTHPATHS, PRIVATEPATHS };
